/* emelsy.js — interactions for the Emelsy landing page (header, gallery, accordions, waitlist forms, sticky CTA) */
(function () {
  'use strict';
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Smooth anchor scroll (offset for sticky header) ---------- */
  function goTo(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: Math.max(0, y), behavior: rm ? 'auto' : 'smooth' });
    if (el.hasAttribute('tabindex')) setTimeout(function () { el.focus({ preventScroll: true }); }, rm ? 0 : 450);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var t = document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    closeMenus();
    goTo(t);
  });

  /* ---------- Header ---------- */
  function closeMenus() {
    document.querySelectorAll('[data-emelsy-header].menu-open').forEach(function (h) {
      h.classList.remove('menu-open');
      var b = h.querySelector('[data-emelsy-burger]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', b.dataset.openLabel || 'Open menu'); }
    });
    updSticky();
  }
  function initHeader(root) {
    root.querySelectorAll('[data-emelsy-header]').forEach(function (h) {
      if (h.dataset.ready) return; h.dataset.ready = '1';
      var b = h.querySelector('[data-emelsy-burger]');
      if (b) b.addEventListener('click', function () {
        var open = !h.classList.contains('menu-open');
        h.classList.toggle('menu-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.setAttribute('aria-label', open ? (b.dataset.closeLabel || 'Close menu') : (b.dataset.openLabel || 'Open menu'));
        updSticky();
      });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var h = document.querySelector('[data-emelsy-header].menu-open');
    if (h) { closeMenus(); var b = h.querySelector('[data-emelsy-burger]'); if (b) b.focus(); }
  });
  function onScroll() {
    var s = window.scrollY > 40;
    document.querySelectorAll('[data-emelsy-header]').forEach(function (h) { h.classList.toggle('is-scrolled', s); });
    updSticky();
  }

  /* ---------- Gallery carousel ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-emelsy-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var track = g.querySelector('[data-track]');
      var slides = g.querySelectorAll('[data-slide]');
      var thumbs = g.querySelectorAll('[data-thumb]');
      var count = g.querySelector('[data-count]');
      var main = g.querySelector('[data-main]');
      var n = slides.length, idx = 0;
      if (!n) return;
      function go(i) {
        idx = (i + n) % n;
        track.style.transform = 'translateX(-' + idx * 100 + '%)';
        slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
        if (count) count.textContent = (idx + 1) + ' / ' + n;
      }
      g._go = go;
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var p = g.querySelector('[data-prev]'), nx = g.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { go(idx - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx + 1); });
      if (main) {
        main.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        });
        var tx = null, ty = null;
        main.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (tx == null) return;
          var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
        });
      }
      go(0);
    });
  }

  /* ---------- Accordions (one open per group) ---------- */
  function initAcc(root) {
    root.querySelectorAll('[data-emelsy-acc]').forEach(function (group) {
      if (group.dataset.ready) return; group.dataset.ready = '1';
      var btns = group.querySelectorAll('.emelsy-acc__btn');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var open = b.getAttribute('aria-expanded') !== 'true';
          btns.forEach(function (o) {
            o.setAttribute('aria-expanded', 'false');
            var pp = document.getElementById(o.getAttribute('aria-controls')); if (pp) pp.hidden = true;
          });
          if (open) {
            b.setAttribute('aria-expanded', 'true');
            var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = false;
          }
        });
      });
    });
  }

  /* ---------- Waitlist forms ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function initForms(root) {
    root.querySelectorAll('[data-emelsy-wl] form').forEach(function (f) {
      if (f.dataset.ready) return; f.dataset.ready = '1';
      var wl = f.closest('[data-emelsy-wl]');
      var input = f.querySelector('input[type="email"]');
      var status = f.querySelector('[data-status]');
      var btn = f.querySelector('button[type="submit"]');
      function setErr(msg) {
        if (status) { status.textContent = msg; status.classList.add('is-error'); }
        if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      }
      if (input) input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') {
          input.setAttribute('aria-invalid', 'false');
          if (status) { status.textContent = ''; status.classList.remove('is-error'); }
        }
      });
      f.addEventListener('submit', function (e) {
        var v = (input && input.value || '').trim();
        if (!v) { e.preventDefault(); return setErr(wl.dataset.msgEmpty || 'Please enter your email address.'); }
        if (!EMAIL_RE.test(v)) { e.preventDefault(); return setErr(wl.dataset.msgInvalid || 'Please enter a valid email address.'); }
        input.value = v;
        try { sessionStorage.setItem('emelsy-wl-src', wl.dataset.emelsyWl || ''); } catch (err) {}
        if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; btn.textContent = wl.dataset.msgSending || 'Joining…'; }
      });
    });
    /* After Shopify redirects back (?customer_posted=true) show success only on the form that was submitted */
    var src = null;
    try { src = sessionStorage.getItem('emelsy-wl-src'); } catch (err) {}
    if (src && /customer_posted=true/.test(location.search)) {
      root.querySelectorAll('[data-emelsy-wl]').forEach(function (wl) {
        if (wl.dataset.emelsyWl !== src && wl.querySelector('[data-done]')) {
          var d = wl.querySelector('[data-done]'), fm = wl.querySelector('[data-form-fallback]');
          if (d && fm) { d.hidden = true; fm.hidden = false; }
        }
      });
      var target = document.querySelector('[data-emelsy-wl="' + src + '"]');
      if (target) setTimeout(function () { goTo(target); }, 50);
      try { sessionStorage.removeItem('emelsy-wl-src'); } catch (err) {}
    }
  }

  /* ---------- Sticky CTA ---------- */
  function updSticky() {
    var st = document.querySelector('[data-emelsy-sticky]');
    if (!st) return;
    if (st.classList.contains('is-editing')) return;
    var hero = document.querySelector('[data-emelsy-wl="hero"],[data-emelsy-buy="hero"]');
    var fin = document.querySelector('[data-emelsy-wl="final"],[data-emelsy-buy="final"]');
    var vh = window.innerHeight;
    var ae = document.activeElement;
    var typing = ae && ae.tagName === 'INPUT';
    var menu = !!document.querySelector('[data-emelsy-header].menu-open');
    var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > vh;
    var fr = fin ? fin.getBoundingClientRect() : null;
    var finIn = fr && fr.top < vh && fr.bottom > 0;
    var on = past && !finIn && !menu && !typing;
    st.classList.toggle('is-visible', on);
    document.body.classList.toggle('emelsy-sticky-on', on);
  }
  function initSticky(root) {
    root.querySelectorAll('[data-emelsy-sticky] [data-sticky-go]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var hero = document.querySelector('[data-emelsy-wl="hero"],[data-emelsy-buy="hero"]');
        var fin = document.querySelector('[data-emelsy-wl="final"],[data-emelsy-buy="final"]');
        var hr = hero ? hero.getBoundingClientRect() : null, fr = fin ? fin.getBoundingClientRect() : null;
        var dH = hr ? Math.abs(hr.top) : Infinity, dF = fr ? Math.abs(fr.top - window.innerHeight) : Infinity;
        goTo(dF < dH ? fin : hero);
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(root) {
    root.querySelectorAll('[data-emelsy-qty]').forEach(function (q) {
      if (q.dataset.ready) return; q.dataset.ready = '1';
      var inp = q.querySelector('input');
      q.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(inp.value, 10) || 1;
          v = Math.min(parseInt(inp.max, 10) || 99, Math.max(1, v + parseInt(b.dataset.step, 10)));
          inp.value = v;
        });
      });
    });
    root.querySelectorAll('.emelsy-buy__form, .emelsy-sticky__form').forEach(function (f) {
      if (f.dataset.ready) return; f.dataset.ready = '1';
      f.addEventListener('submit', function () {
        var b = f.querySelector('[type="submit"]');
        if (b) { b.setAttribute('aria-busy', 'true'); b.style.opacity = '.7'; }
      });
    });
  }

  function init(root) {
    root = root || document;
    initHeader(root); initGallery(root); initAcc(root); initForms(root); initSticky(root); initQty(root);
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updSticky);
  document.addEventListener('focusin', function () { setTimeout(updSticky, 0); });
  document.addEventListener('focusout', function () { setTimeout(updSticky, 0); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var st = e.target.querySelector('[data-emelsy-sticky]');
    if (st) st.classList.add('is-editing', 'is-visible');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var st = e.target.querySelector('[data-emelsy-sticky]');
    if (st) { st.classList.remove('is-editing'); updSticky(); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    var g = slide && slide.closest('[data-emelsy-gallery]');
    if (g && g._go) g._go(Array.prototype.indexOf.call(g.querySelectorAll('[data-slide]'), slide));
  });
})();
